import problema01 from "./cartas/problema-01.webp";
import problema02 from "./cartas/problema-02.webp";
import problema03 from "./cartas/problema-03.webp";
import problema04 from "./cartas/problema-04.webp";
import problema05 from "./cartas/problema-05.webp";
import problema06 from "./cartas/problema-06.webp";
import problema07 from "./cartas/problema-07.webp";
import problema08 from "./cartas/problema-08.webp";
import problema09 from "./cartas/problema-09.webp";
import problema10 from "./cartas/problema-10.webp";
import raroAjuda from "./cartas/raro-ajuda.webp";
import raroAmeaca from "./cartas/raro-ameaca.webp";
import solucao01 from "./cartas/solucao-01.webp";
import solucao02 from "./cartas/solucao-02.webp";
import solucao03 from "./cartas/solucao-03.webp";
import solucao04 from "./cartas/solucao-04.webp";
import solucao05 from "./cartas/solucao-05.webp";
import solucao06 from "./cartas/solucao-06.webp";
import solucao07 from "./cartas/solucao-07.webp";
import solucao08 from "./cartas/solucao-08.webp";
import solucao09 from "./cartas/solucao-09.webp";
import solucao10 from "./cartas/solucao-10.webp";

// As 22 cartas de Centro-Oeste / Cerrado — o dado, separado do
// descritor. Transcritas de Cards_Curiosidade_Centro-Oeste.md por
// ferramentas-da-trilha/gerar-cartas-trilha.py, e não à mão: o erro
// provável numa transcrição de 22 textos é a pílula de um card cair em
// outro, e nenhum teste pega isso.
//
// O NOME DO ARQUIVO É O ID, sem o prefixo da região (a pasta já é a
// região). `card_id` é a CHAVE da coleção do aluno em
// `activity_ludic_trail_collection` e não se renomeia depois de gravada.
//
// Sem campo `fase`: a posição na trilha vem do sorteio.

// Banco fixo de 20: o sorteio tira 4 por trilha sem repetir (ver
// ava/progressoDoAluno.js), e o tamanho do banco é o que dá chance de
// carta nova quando o aluno refaz.
export const CARDS_COMUNS_CENTRO_OESTE = [
  {
    id: "centro-oeste-problema-01",
    tipo: "problema",
    nome: "Lavoura no Lugar do Campo",
    asset: problema01,
    pilula:
      "Plantações imensas de soja e cana tomam o lugar do campo nativo, e o lobo-guará perde o território enorme de que precisa pra caçar."
  },
  {
    id: "centro-oeste-problema-02",
    tipo: "problema",
    nome: "Atropelamentos nas Rodovias",
    asset: problema02,
    pilula:
      "Estradas cortam o Cerrado no meio, e o atropelamento é hoje a principal causa de morte do lobo-guará."
  },
  {
    id: "centro-oeste-problema-03",
    tipo: "problema",
    nome: "Queimadas Fora de Época",
    asset: problema03,
    pilula:
      "O Cerrado convive com fogo natural, mas queimada na época errada foge do controle e queima o capim alto onde o lobo-guará esconde os filhotes."
  },
  {
    id: "centro-oeste-problema-04",
    tipo: "problema",
    nome: "Veredas Secando",
    asset: problema04,
    pilula:
      "As veredas de buriti são as fontes de água do Cerrado — quando secam, o lobo-guará perde onde beber e os bichos que caça por ali."
  },
  {
    id: "centro-oeste-problema-05",
    tipo: "problema",
    nome: "Doenças de Cachorro",
    asset: problema05,
    pilula:
      "Cães domésticos soltos perto das reservas passam doenças como a cinomose pro lobo-guará, que não tem quem o vacine na natureza."
  },
  {
    id: "centro-oeste-problema-06",
    tipo: "problema",
    nome: "Cães Soltos no Cerrado",
    asset: problema06,
    pilula:
      "Matilhas de cães sem dono disputam comida com o lobo-guará e chegam a atacar ele e seus filhotes."
  },
  {
    id: "centro-oeste-problema-07",
    tipo: "problema",
    nome: "Perseguido por Causa das Galinhas",
    asset: problema07,
    pilula:
      "Quando fica sem caça no campo, o lobo-guará se aproxima dos galinheiros — e acaba morto por quem o culpa pelo prejuízo."
  },
  {
    id: "centro-oeste-problema-08",
    tipo: "problema",
    nome: "Cerrado em Pedaços",
    asset: problema08,
    pilula:
      "Cercas, fazendas e cidades dividem o Cerrado, e o lobo-guará fica ilhado num pedaço pequeno, sem encontrar um par pra formar casal."
  },
  {
    id: "centro-oeste-problema-09",
    tipo: "problema",
    nome: "Sem Lobeira, Sem Remédio",
    asset: problema09,
    pilula:
      "A lobeira é a fruta preferida do lobo-guará e ajuda a protegê-lo de um verme perigoso — sem esse arbusto nativo, ele adoece mais."
  },
  {
    id: "centro-oeste-problema-10",
    tipo: "problema",
    nome: "Capim de Fora",
    asset: problema10,
    pilula:
      "Capins trazidos de outros países sufocam as plantas nativas do Cerrado e afastam as presas que o lobo-guará caça."
  },
  {
    id: "centro-oeste-solucao-01",
    tipo: "solucao",
    nome: "Cientistas de Olho",
    asset: solucao01,
    pilula:
      "Coleiras com GPS e câmeras escondidas no mato revelam por onde o lobo-guará anda e quantos filhotes nasceram — e mostram onde proteger primeiro."
  },
  {
    id: "centro-oeste-solucao-02",
    tipo: "solucao",
    nome: "Motorista Atento no Cerrado",
    asset: solucao02,
    pilula:
      "Placas de alerta e redutores nos trechos de mata fazem o carro diminuir justo ao anoitecer, quando o lobo-guará sai pra caçar."
  },
  {
    id: "centro-oeste-solucao-03",
    tipo: "solucao",
    nome: "Vacinar os Cães da Vizinhança",
    asset: solucao03,
    pilula:
      "Vacinar os cachorros das casas e fazendas em volta das reservas impede que doenças como a cinomose cheguem ao lobo-guará."
  },
  {
    id: "centro-oeste-solucao-04",
    tipo: "solucao",
    nome: "Galinheiro Bem Fechado",
    asset: solucao04,
    pilula:
      "Um galinheiro telado e fechado à noite protege as galinhas e, junto com elas, o lobo-guará, que deixa de ser perseguido."
  },
  {
    id: "centro-oeste-solucao-05",
    tipo: "solucao",
    nome: "Cuidar das Veredas",
    asset: solucao05,
    pilula:
      "Proteger as veredas de buriti e as nascentes mantém a água do Cerrado corrente — e o lobo-guará com onde beber o ano inteiro."
  },
  {
    id: "centro-oeste-solucao-06",
    tipo: "solucao",
    nome: "Fogo na Época Certa",
    asset: solucao06,
    pilula:
      "Aceiros e queimas controladas fora da seca evitam o incêndio grande e mantêm o Cerrado saudável do jeito que o lobo-guará precisa."
  },
  {
    id: "centro-oeste-solucao-07",
    tipo: "solucao",
    nome: "Plantar Lobeira e Nativas",
    asset: solucao07,
    pilula:
      "Plantar lobeira, pequi e outras nativas devolve ao lobo-guará a fruta que ele come — e ele retribui espalhando as sementes pelo Cerrado."
  },
  {
    id: "centro-oeste-solucao-08",
    tipo: "solucao",
    nome: "Corredores de Cerrado",
    asset: solucao08,
    pilula:
      "Faixas de campo e mata ligando as áreas isoladas devolvem ao lobo-guará o caminho livre pra circular e achar um par."
  },
  {
    id: "centro-oeste-solucao-09",
    tipo: "solucao",
    nome: "Parques e Reservas",
    asset: solucao09,
    pilula:
      "Áreas protegidas por lei, como o Parque das Emas e a Chapada dos Veadeiros, garantem Cerrado de sobra pro lobo-guará viver."
  },
  {
    id: "centro-oeste-solucao-10",
    tipo: "solucao",
    nome: "Contar essa História",
    asset: solucao10,
    pilula:
      "O lobo-guará é tão importante que está estampado na nota de 200 reais — mostrar isso pra mais gente ajuda a protegê-lo, como você agora!"
  }
];

// Fora do sorteio: o arco do mascote, em 1ª pessoa. A ORDEM importa, e o
// casamento é ALINHADO PELO FIM (ver nucleo/recompensaDaFase.js) — numa
// trilha de 2 a 4 passos existe uma fase rara só, e ela tem de receber o
// FECHO. O último item é o único que todo aluno vê, e o único com
// `comemorar: true`.
export const CARDS_RAROS_CENTRO_OESTE = [
  {
    id: "centro-oeste-raro-ameaca",
    tipo: "raro",
    nome: "O Cerrado em Perigo",
    asset: raroAmeaca,
    pilula:
      "Meu campo está virando lavoura, e as estradas cortam justo por onde eu passo — corro perigo só pra atravessar. Continue a exploração pra me ajudar a proteger o Cerrado!"
  },
  {
    id: "centro-oeste-raro-ajuda",
    tipo: "raro",
    nome: "Vamos Cuidar do Cerrado!",
    asset: raroAjuda,
    comemorar: true,
    pilula:
      "Graças a você, não estou mais sozinho: carro que reduz, vereda protegida e lobeira plantada mudam minha história. Continue de olho na natureza — cuidar do meu Cerrado é cuidar da sua água!"
  }
];

export const CARDS_CENTRO_OESTE = [
  ...CARDS_COMUNS_CENTRO_OESTE,
  ...CARDS_RAROS_CENTRO_OESTE
];
